import { render, staticRenderFns } from "./LogReceiveNumber.vue?vue&type=template&id=285214a3&"
import script from "./LogReceiveNumber.vue?vue&type=script&lang=js&"
export * from "./LogReceiveNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports